import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/slw/app/providers/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProvider"] */ "/app/slw/app/providers/client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialogProvider"] */ "/app/slw/app/providers/dialog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTagProvider"] */ "/app/slw/app/providers/gtag-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/slw/app/providers/query-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/slw/app/styles/pre-global.scss");
;
import(/* webpackMode: "eager" */ "/app/slw/app/styles/global.css");
;
import(/* webpackMode: "eager" */ "/app/slw/app/styles/main.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-plus-jakarta\",\"display\":\"swap\"}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../slw/app/fonts/Magneto.ttf\",\"variable\":\"--font-magneto\",\"display\":\"swap\"}],\"variableName\":\"magneto\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/slw/shared/ui/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatWidget"] */ "/app/slw/widgets/common/chat-widget.ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/slw/widgets/master-layout/footer.ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/slw/widgets/master-layout/header.ui.tsx");
